import { useCallback } from 'react';
import { HStack, Stack, Text } from '@adc/parallax-component-library';
import { createFileRoute } from '@tanstack/react-router';

import { SignInForm } from '~/components/SignInForm';
import { buildTestId } from '~/utils/buildTestId';
import { publicRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/login')({
  component: RouteComponent,
  beforeLoad: publicRoute,
});

const TEST_ID = 'login-page';

function RouteComponent() {
  const navigate = Route.useNavigate();

  const onSuccessLogin = useCallback(() => {
    void navigate({ to: '/', replace: true });
  }, [navigate]);

  return (
    <HStack flex={1} flexBasis="50%" margin={0} padding={0}>
      <Stack
        flex={1}
        flexBasis="50%"
        justifyContent="center"
        alignItems="center"
        backgroundColor="$neutral.20"
        paddingBottom="$4"
        testID={TEST_ID}
      >
        <Stack flex={1} padding="$6" gap="$6" marginTop={124}>
          <HStack flex={1} gap="$9">
            <Stack
              height={60}
              width={8}
              backgroundColor="$blue10Light"
              borderRadius={8}
            />
            <Stack flex={4} gap="$4">
              <Text
                type="$h2.medium"
                testID={buildTestId({ testID: TEST_ID, suffix: 'title' })}
              >
                One system, multiple reports, easy sharing
              </Text>

              <Text
                type="$bodyBase.medium"
                maxWidth={600}
                testID={buildTestId({ testID: TEST_ID, suffix: 'description' })}
              >
                With LactateView, healthcare professionals can track patient
                progress with clear, easy-to-understand, customizable reports.
                LactateView also allows patients to easily share their info with
                their healthcare professional.
              </Text>
            </Stack>
          </HStack>
        </Stack>
      </Stack>
      <Stack
        flex={1}
        flexBasis="50%"
        padding="$6"
        backgroundColor="$surface.background"
        justifyContent="center"
        alignItems="center"
      >
        <SignInForm onSuccess={onSuccessLogin} />
      </Stack>
    </HStack>
  );
}
